function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonProjector = function SvgButtonProjector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m23.983 16.43.473-4.241-2.848.165a6.29 6.29 0 0 0 3.237-5.487 6.12 6.12 0 0 0-6.31-6.31 6.31 6.31 0 0 0-6.312 6.31c0 .163.013.324.025.484a4.26 4.26 0 0 0-3.883-2.518 4.09 4.09 0 0 0-4.266 4.266 4.25 4.25 0 0 0 3.133 4.092l-2.363.138.744 9.511 5.992.308-3.095 5.576 2.336.855 2.398-6.346 2.78.143 2.322 6.17 2.151-.911-2.853-5.14 5.523.248.417-3.737 2.63 1.003.272-5.78ZM12.727 8.79l-.003-.023a6.1 6.1 0 0 0 3.324 3.472l-.861.05-4.721.154a4.1 4.1 0 0 0 2.26-3.653",
    "data-name": "Header Buttons",
    style: {
      fill: "#ffce41"
    }
  }));
};
export default SvgButtonProjector;